import { render, staticRenderFns } from "./PaginationLabel.vue?vue&type=template&id=6d35d16a&"
import script from "./PaginationLabel.vue?vue&type=script&lang=ts&"
export * from "./PaginationLabel.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports